import { render, staticRenderFns } from "./CustomerServerTable.vue?vue&type=template&id=33aebeea"
import script from "./CustomerServerTable.vue?vue&type=script&lang=js"
export * from "./CustomerServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports